import Vue from 'vue'
import Vuex from 'vuex'

import statusReports from './modules/statusReports'
import authentication from './modules/authentication'
import peerReview from './modules/peerReview'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false
  },
  mutations: {},
  actions: {},
  modules: { statusReports, authentication, peerReview }
})
